import { call, takeEvery } from 'redux-saga/effects';

import { getLogger } from '../../utils/core';

import * as actions from './bumpActions';
import { send } from './bumpInstance';

const log = getLogger('flux/bump/bumpSagas');

const RESOURCE_UPDATERS = {};

// !!! important - NEVER subscribe from shared package to avoid multi-instance subscription conflicts
// subscribe only from main client code side
export const subscribeForBumpUpdates = (resourceType, dumpUpdater, nudgeUpdater, jobUpdater) => {
  RESOURCE_UPDATERS[resourceType] = {
    CHANGE_DUMP: dumpUpdater,
    CHANGE_NUDGE: nudgeUpdater,
    JOB_STATUS: jobUpdater,
  };
};

function* receiveBumpMessage({ payload: message }) {
  let updater;
  if (message.type) {
    switch (message.type) {
      case 'JOB_STATUS':
        updater = RESOURCE_UPDATERS[message.data.jobType]?.[message.type];
        if (updater) {
          yield call(updater, message.data);
        }
        if (!updater) {
          log.info('Unhandled bump jobType', message.data.jobType);
        }
        break;
      case 'CHANGE_DUMP':
      case 'CHANGE_NUDGE':
        updater = RESOURCE_UPDATERS[message.data.resourceType]?.[message.type];
        if (updater) {
          yield call(updater, message.data.resources);
        }
        if (!updater) {
          log.info('Unhandled bump resource', message.data.resourceType);
        }
        break;
      default:
        log.info('Unhandled bump message type', message.type, message);
    }
  } else if (message.eventType) {
    updater = RESOURCE_UPDATERS[message.eventType]?.CHANGE_NUDGE;
    if (updater) {
      yield call(updater, message);
    }
  } else {
    log.info('Unhandled bump message', message);
  }
}

function* sendBumpMessage({ payload: message }) {
  yield call(send, typeof message === 'string' ? message : JSON.stringify(message));
}

function* receiveBumpMessageActionWatcher() {
  yield takeEvery(actions.receivedBumpMessage, receiveBumpMessage);
}

function* sendBumpMessageActionWatcher() {
  yield takeEvery(actions.sendBumpMessage, sendBumpMessage);
}

export default [receiveBumpMessageActionWatcher, sendBumpMessageActionWatcher];
